var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Dialog, DIALOG_SIZE } from "../Dialog";
import { STACK_ALIGN, STACK_DIRECTION, STACK_DISTRIBUTION, StackView } from "../StackView";
import { SPACE_FILL } from "../View";
import { createUIElement } from "../helpers";
export var DialogWizardLayout = createUIElement('DialogWizardLayout', function (_a, ref) {
    var className = _a.className, loading = _a.loading, pending = _a.pending, dialogHeader = _a.dialogHeader, body = _a.body, footer = _a.footer, _b = _a.size, size = _b === void 0 ? { height: DIALOG_SIZE.l, width: DIALOG_SIZE.l } : _b, onRequestClose = _a.onRequestClose, tabs = _a.tabs, content = _a.content, contentHeader = _a.contentHeader, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "loading", "pending", "dialogHeader", "body", "footer", "size", "onRequestClose", "tabs", "content", "contentHeader", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyPress", "style"]);
    return (React.createElement(Dialog, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'dialog-wizard', className: "vm-DialogWizardLayout " + className, hasSpacing: false, loading: loading, pending: pending, header: dialogHeader || '', actionFooter: footer, size: size, onRequestClose: onRequestClose, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(StackView, { root: true, clipped: true, direction: STACK_DIRECTION.row, distribution: STACK_DISTRIBUTION.lastFill, align: STACK_ALIGN.fill, spaceFill: SPACE_FILL.all },
            tabs,
            body ? (body) : (React.createElement(StackView, { root: true, clipped: true, direction: STACK_DIRECTION.column, align: STACK_ALIGN.fill, distribution: STACK_DISTRIBUTION.lastFill },
                contentHeader,
                content)))));
});
//# sourceMappingURL=DialogWizardLayout.js.map